

import AudioManager from "../manager/audio_manager"
import GrayLable from "../pacakge/public/ui/GrayLable";
import { Base64 } from "../utility/base64"
import AppController, { AnalyticsEvent, AnalyticsParam } from "../sdk/app_controller";

let grayMateral
let normalMaterial
let URLJS

export default class Utility {

    static _lastClickTime = 0
    static _lastAnimTime = 0
    static _screenSize: cc.Size = null

    static random(min: number, max: number): number {

        let range = max - min;

        return min + Math.random() * range;
    }

    static randomToInt(min: number, max: number): number {

        let range = max - min;

        return Math.round(min + Math.random() * range);
    }

    static randomInsideRadius(radius: number = 1): cc.Vec2 {

        let vec = new cc.Vec2();
        vec.x = this.random(-radius, radius);

        vec.y = Math.sqrt(radius * radius - vec.x * vec.x) * this.random(-1, 1);

        return vec;
    }

    static atob(base64: string): string {
        return Base64.atob(base64);
    }

    static decodeBase64(content: string) {
        return Base64.decode(content);
    }

    static encodeBase64(content: string) {
        return Base64.encode(content);
    }
    static encryptAES(word, key) {
        return Base64.encrypt(word, key);
    }

    static decryptAES(word, key): string {
        return Base64.decrypt(word, key);
    }

    static nowTimestamp(): number {
        return Math.floor(Date.now() * 0.001)
    }

    static jsonParse<T>(str, reviver?): T {
        if (typeof str == 'string') {
            try {
                let obj = JSON.parse(str, reviver)
                if (typeof obj == "object") {
                    return obj;
                }
            } catch (e) {
            }
        }
        return null;
    }

    static parseInt(content): number {
        return parseInt(content);
    }

    /**
     * 比较两个obj的内容是否相等
     * @param a 
     * @param b 
     */
    static isEqualWithObjValue(a : any,b : any){
        if (!a || !b) {
            return false;
        }

        return JSON.stringify(a) == JSON.stringify(b);        
    }

    static filterPlayerGoldNum(num: number) {
        if (num > 9999 && num < 100000000) {
            let n = (Math.floor(parseFloat(num.toString()) / 10000 * 10) / 10).toFixed(1)
            return n + "万"
        }
        else if (num > 99999999) {
            let n = (Math.floor(parseFloat(num.toString()) / 100000000 * 100) / 100).toFixed(2)
            return n + "亿"
        }
        return "" + num
    }

    static setBtnGray(btn: cc.Button, isGray: boolean) {
        if (btn == null) {
            cc.warn("置灰按钮为null")
            return
        }
        btn.interactable = !isGray;
        btn.enableAutoGrayEffect = isGray;

    }
    static setBjBtnGray(btn: cc.Button, isGray: boolean) {
        if (btn == null) {
            cc.warn("置灰按钮为null")
            return
        }
        btn.interactable = !isGray;
        btn.enableAutoGrayEffect = isGray;
        let child = btn.node.getChildByName("New Sprite")
        if (child) {
            Utility.setNodeGray(child, isGray)
        }
    }
    static setNodeGray(node: cc.Node, isGray: boolean) {
        let coms = this.getAllComponets(node, cc.Sprite)
        for (let i = 0; i < coms.length; i++) {
            const element = coms[i];
            if (isGray) {
                this.setGray(element)
            } else {
                this.resetGray(element)
            }
        }
        let labels = this.getAllComponets(node, cc.Label)
        for (let i = 0; i < labels.length; i++) {
            const element = labels[i];
            if (isGray) {
                this.setGray(element)
            } else {
                this.resetGray(element)
            }
        }

        let grayLabls = this.getAllComponets(node, GrayLable)
        for (let i = 0; i < grayLabls.length; i++) {
            const element = grayLabls[i];
            if (isGray) {
                element.enabled = true
            } else {
                element.enabled = false
            }
        }
    }

    static getAllComponets<T extends cc.Component>(node: cc.Node, type: { prototype: T }): T[] {
        let coms: T[] = []
        coms = node.getComponents(type)
        if (node.childrenCount > 0) {
            for (let index = 0; index < node.children.length; index++) {
                const child = node.children[index];
                child && (coms = coms.concat(this.getAllComponets(child, type)))
            }
        }
        return coms
    }



    static isGray(sp: cc.Sprite): boolean {
        return sp.getState() == cc.Sprite.State.GRAY
    }

    //图片置灰
    static setGray(sp: cc.Sprite | cc.Label) {
        //@ts-ignore
        grayMateral = grayMateral || cc.Material.getBuiltinMaterial("2d-gray-sprite");
        // sp.setState(cc.Sprite.State.GRAY)//置灰
        sp.setMaterial(0, grayMateral)
        if (sp instanceof cc.Label) {
            sp['_forceUpdateRenderData']()
        }
    }

    //取消图片置灰
    static resetGray(sp: cc.Sprite | cc.Label) {
        //@ts-ignore
        normalMaterial = normalMaterial || (normalMaterial = cc.Material.getBuiltinMaterial("2d-sprite", sp));
        // sp.setState(cc.Sprite.State.NORMAL) //正常
        sp.setMaterial(0, normalMaterial)
        if (sp instanceof cc.Label) {
            sp['_forceUpdateRenderData']()
        }
    }

    //时间format yyyy-MM-dd hh:mm
    static formatTime(timestamp?: number, pattern?: string) {
        var date = null
        if (timestamp == null) {
            date = new Date()
        } else {
            date = new Date(timestamp * 1000);
        }

        if (pattern == null || pattern == "") {
            pattern = "yyyy-MM-dd hh:mm"
        }

        let o = {
            "M+": date.getMonth() + 1,
            "d+": date.getDate(),
            "h+": date.getHours(),
            "m+": date.getMinutes(),
            "s+": date.getSeconds(),
            "q+": Math.floor((date.getMonth() + 3) / 3),
            "S": date.getMilliseconds()
        };

        if (/(y+)/.test(pattern)) {
            pattern = pattern.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
        }

        for (var k in o) {
            if (new RegExp("(" + k + ")").test(pattern)) {
                pattern = pattern.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length));
            }
        }
        return pattern
    }

    //time服务器传的时间戳
    static getDate(time) {
        let date = new Date(time.replace(/-/g, '/'))
        let year = date.getFullYear() < 10 ? "0" + date.getFullYear() : "" + date.getFullYear()
        let month = (date.getMonth() + 1) < 10 ? "0" + (date.getMonth() + 1) : "" + (date.getMonth() + 1)
        let day = date.getDate() < 10 ? "0" + date.getDate() : "" + date.getDate()
        let data = { year: year, month: month, day: day }
        return data
    }

    static notIOS() {
        if (!this.isMobile()) {
            return true
        }
        return cc.sys.OS_IOS != cc.sys.os
    }

    static isMobile() {
        return cc.sys.isMobile
    }

    static isNativeIOS() {
        return cc.sys.isNative && cc.sys.os == cc.sys.OS_IOS
    }

    static isNativeAndroid() {
        return cc.sys.isNative && cc.sys.os == cc.sys.OS_ANDROID
    }

    static platformName() {
        if (cc.sys.isNative) {
            if (cc.sys.os == cc.sys.OS_ANDROID) {
                return "android"
            } else if (cc.sys.os == cc.sys.OS_IOS) {
                return "ios"
            }
            return "android"
        }
        return cc.sys.os.toLowerCase()
    }
  
    static filterPlayerName(name: string, maxCharLen: number = 8) {

        return this.strClamp(name,maxCharLen,"..");
    }

    //str 需要截断的字符串
    //maxChars 保留的字符长度(英文、泰文算一个，汉字算2个)
    //suffix 添加的后缀 （注意，如果后缀不为null或者'' ，则要占用一个汉字的位置,具体看下方的示例代码)
    static strClamp(str : string, maxChars : number = 8, suffix = ".." ) {
        var toCodePoint = function (unicodeSurrogates : string) {
            var r = [], c = 0, p = 0, i = 0;
            while (i < unicodeSurrogates.length) {
                var pos = i;
                c = unicodeSurrogates.charCodeAt(i++);//返回位置的字符的 Unicode 编码 
                if (c == 0xfe0f) {
                    continue;
                }
                if (p) {
                    var value = (0x10000 + ((p - 0xD800) << 10) + (c - 0xDC00));
                    r.push({
                        v: value,
                        pos: pos,
                    }); //计算4字节的unicode
                    p = 0;
                } else if (0xD800 <= c && c <= 0xDBFF) {
                    p = c; //如果unicode编码在oxD800-0xDBff之间，则需要与后一个字符放在一起
                } else {
                    r.push({
                        v: c,
                        pos: pos
                    }); //如果是2字节，直接将码点转为对应的十六进制形式
                }
            }
            return r;
        }
        // maxChars *= 2;

        var codeArr = toCodePoint(str);
        var numChar = 0;
        var index = 0;
        for (var i = 0; i < codeArr.length; ++i) {
            var code = codeArr[i].v;
            var add = 1;    
            //泰文区间 3584 	3711
            if (code >= 128 && code < 3584 || code > 3711) {
                add = 2;
            }

            //如果超过了限制，则按上一个为准
            if (numChar + add > maxChars) {
                break;
            }

            index = i;

            //累加
            numChar += add;
        }

        let clampIndex = index;
        if (codeArr.length - 1 == index) {
            return  str;
        }

        var more = suffix ? 1 : 0;

        clampIndex = codeArr[index - more].pos + 1;
        return str.substring(0, clampIndex) + suffix;
    }

     //str 需要截断的字符串
    //maxChars 保留的字符长度(英文、泰文算一个，汉字算2个)
    //suffix 添加的后缀 （注意，如果后缀不为null或者'' ，则要占用一个汉字的位置,具体看下方的示例代码)
    static strClampIndex(str : string, maxChars : number = 8, suffix = ".." ) {
        var toCodePoint = function (unicodeSurrogates : string) {
            var r = [], c = 0, p = 0, i = 0;
            while (i < unicodeSurrogates.length) {
                var pos = i;
                c = unicodeSurrogates.charCodeAt(i++);//返回位置的字符的 Unicode 编码 
                if (c == 0xfe0f) {
                    continue;
                }
                if (p) {
                    var value = (0x10000 + ((p - 0xD800) << 10) + (c - 0xDC00));
                    r.push({
                        v: value,
                        pos: pos,
                    }); //计算4字节的unicode
                    p = 0;
                } else if (0xD800 <= c && c <= 0xDBFF) {
                    p = c; //如果unicode编码在oxD800-0xDBff之间，则需要与后一个字符放在一起
                } else {
                    r.push({
                        v: c,
                        pos: pos
                    }); //如果是2字节，直接将码点转为对应的十六进制形式
                }
            }
            return r;
        }
        // maxChars *= 2;

        var codeArr = toCodePoint(str);
        var numChar = 0;
        var index = 0;
        for (var i = 0; i < codeArr.length; ++i) {
            var code = codeArr[i].v;
            var add = 1;    
            //泰文区间 3584 	3711
            if (code >= 128 && code < 3584 || code > 3711) {
                add = 2;
            }

            //如果超过了限制，则按上一个为准
            if (numChar + add > maxChars) {
                break;
            }

            index = i;

            //累加
            numChar += add;
        }

        let clampIndex = index;
        if (codeArr.length - 1 == index) {
            return  {str : str, index : clampIndex};
        }

        var more = suffix ? 1 : 0;

        clampIndex = codeArr[index - more].pos + 1;
        return {str :str.substring(0, clampIndex) + suffix, index : clampIndex};
    }

    //隐藏所有子对象
    static hideAllChildren(parent: cc.Node) {
        let length = parent.childrenCount
        for (let i = 0; i < length; i++) {
            parent.children[i].active = false
        }
    }

    //获取[under,over]之间整数随机值
    static getIntRandom(under: number = 0, over: number = 0) {
        return Math.floor(Math.random() * (over - under + 1) + under)
    }

    //播放按钮点击声音
    static playButtonSound() {
        let url = "sound/public/button"
        AudioManager.instance.playSound(url, false)
    }


    //两个number数组是否相等
    static isNumArrayEquel(a: number[], b: number[]) {
        if (a.length != b.length) {
            return false
        }
        for (let i = 0; i < a.length; i++) {
            let index = b.indexOf(a[i])
            if (index < 0) {
                return false
            }
        }
        return true
    }

    // 时间戳
    static timeStamp() {
        return "" + (new Date().getTime() / 1000)
    }

    // 随机数
    static randomString() {
        var chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678';    /****默认去掉了容易混淆的字符oOLl,9gq,Vv,Uu,I1****/
        var maxPos = chars.length;
        var pwd = '';
        for (var i = 0; i < 32; i++) {
            pwd += chars.charAt(Math.floor(Math.random() * maxPos));
        }
        return pwd;
    }

    //重置sprite大小
    static resetSpriteSize(sprite: cc.Sprite, maxWH?: number) {
        if (maxWH) {
            let v2 = sprite.spriteFrame.getOriginalSize()
            let max = Math.max(v2.width, v2.height)
            let scale = 1
            if (max > maxWH) {
                scale = maxWH / max
            }
            sprite.node.setContentSize(v2.width * scale, v2.height * scale)
        } else {
            let v2 = sprite.spriteFrame.getOriginalSize()
            sprite.node.setContentSize(v2)
        }
    }

    static scaleSpriteToSize(sprite: cc.Sprite, spriteFrame: cc.SpriteFrame, maxWH: number) {
        let v2 = spriteFrame.getOriginalSize()
        let width = v2.width
        let height = v2.height
        if (width > height) {
            width = maxWH
            height = (v2.height / v2.width) * maxWH
        } else {
            height = maxWH
            width = (v2.width / v2.height) * maxWH
        }
        sprite.spriteFrame = spriteFrame
        sprite.node.setContentSize(width, height)
    }

    //防止打断动画播放
    static lastAnimValid(intervalTime?: number) {
        let time = 300
        if (intervalTime) {
            time = intervalTime
        }
        let cur = new Date().getTime()
        if (cur - this._lastAnimTime < time) {
            return false
        } else {
            this._lastAnimTime = cur
            return true
        }
    }

    //防止用户连续点击
    static btnClickValid(intervalTime?: number) {
        let time = 400
        if (intervalTime) {
            time = intervalTime
        }
        let cur = new Date().getTime()
        if (cur - this._lastClickTime < time) {
            return false
        } else {
            this._lastClickTime = cur
            return true
        }
    }

    static getLabelSize(str: string, label: cc.Label) {
        label.string = str
        //@ts-ignore
        label._forceUpdateRenderData(true)//cocos 2.0.1版本以后用此方法可以刷新label的宽高
        return label.node.getContentSize()
    }

    static getPrefabNode(index: number, parent: cc.Node, prefab: cc.Node): cc.Node {
        if (parent.childrenCount <= index) {
            var node = cc.instantiate(prefab)
            node.position = cc.v2(0, 0)
            node.scale = 1
            node.parent = parent
            node.active = false
            return this.getPrefabNode(index, parent, prefab)
        }
        else {
            return parent.children[index]
        }
    }


    static getStrLength(str) {
        if (str) {
            return 0
        }
        var toCodePoint = function (unicodeSurrogates) {
            var r = [], c = 0, p = 0, i = 0;
            while (i < unicodeSurrogates.length) {
                var pos = i;
                c = unicodeSurrogates.charCodeAt(i++);//返回位置的字符的 Unicode 编码
                if (c == 0xfe0f) {
                    continue;
                }
                if (p) {
                    var value = (0x10000 + ((p - 0xD800) << 10) + (c - 0xDC00));
                    r.push({
                        v: value,
                        pos: pos,
                    }); //计算4字节的unicode
                    p = 0;
                } else if (0xD800 <= c && c <= 0xDBFF) {
                    p = c; //如果unicode编码在oxD800-0xDBff之间，则需要与后一个字符放在一起
                } else {
                    r.push({
                        v: c,
                        pos: pos
                    }); //如果是2字节，直接将码点转为对应的十六进制形式
                }
            }
            return r;
        }

        var codeArr = toCodePoint(str);
        var numChar = 0;

        for (var i = 0; i < codeArr.length; ++i) {
            var code = codeArr[i].v;
            var add = 1;
            if (code >= 128) {
                add = 2;
            }
            numChar += add;
        }

        return numChar
    }

    static resetAnimation(anim: cc.Animation) {
        if (!anim) {
            return
        }
        anim.setCurrentTime(0)
    }

    static findChildNode(node: cc.Node, path: string): cc.Node {
        let index = path.indexOf('/')
        if (index > 0) {
            let name = path.substring(0, index)
            if (index + 1 < path.length) {
                path = path.substring(index + 1)
                let child = node.getChildByName(name)
                if (child) {
                    return this.findChildNode(child, path)
                }
                return null
            } else {
                return node.getChildByName(name)
            }
        } else {
            return node.getChildByName(path)
        }

    }

    // 货币格式
    static currencyFormatting(num: number, isInt: boolean = false) {
        let sign = num < 0 ? '-' : ''
        num = Math.abs(num)
        let numStr: string = (num.toFixed(2) || 0).toString(), result = '';
        let arr = numStr.split(".");
        let beforeStr = arr[0];

        while (beforeStr.length > 3) {
            result = ',' + beforeStr.slice(-3) + result;
            beforeStr = beforeStr.slice(0, beforeStr.length - 3);
        }
        if (beforeStr) { result = beforeStr + result; }
        if (isInt) { return result }
        if (arr.length > 1) {
            result = result + "." + arr[1];
        }
        result = sign + result
        let reg = new RegExp(`\\.[0]{0,}$`, 'g')
        result = result.replace(reg, '')
        return result
    }

    /**
     * 从一个节点移动到另一个节点
     * @param srcNode 开始节点
     * @param destNode 结束节点
     * @param time 运动时间
     * @param srcRadius 开始点随机半径
     * @param destRadius 结束点随机半径
     */
    static moveToArea(srcNode: cc.Node, destNode: cc.Node, time: number, srcRadius?: number, destRadius?: number, callback?: Function) {

        if (!srcNode || !destNode) return;

        if (srcRadius) {

            let offset_src = this.randomInsideRadius(srcRadius);
            srcNode.position = new cc.Vec2(srcNode.position.x + offset_src.x, srcNode.position.y + offset_src.y);
        }

        let destPos = destNode.position;
        if (destRadius) {

            let offset_dest = this.randomInsideRadius(destRadius);
            destPos = new cc.Vec2(destPos.x + offset_dest.x, destPos.y + offset_dest.y);
        }

        destPos = destNode.parent.convertToWorldSpaceAR(destPos);
        destPos = srcNode.parent.convertToNodeSpaceAR(destPos);

        let moveAction = cc.moveTo(time, destPos).easing(cc.easeSineIn());
        srcNode.runAction(cc.sequence(moveAction, cc.callFunc(callback)));

    }
    static numberFormat(num:number) {
        if(num.toString().indexOf('.') !== -1){
            num = Math.round(num * 100) / 100
            num = parseFloat(num.toString())
        }
        var c = (num.toString().indexOf('.') !== -1) ? num.toLocaleString() : num.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,');
        return c;
    }
    static timeToStr(time, formatStr?) {
        let date = new Date(time);
        formatStr = formatStr || 'dd/MM/yyyy hh:mm:ss'
        return date.format(formatStr);
    }

    static splicingStr(num: number) {
        let str = num.toString()
        if (str.length < 2) {
            str = "0" + str
        }
        return str
    }

    /**
     * 下载文件接口  
     * @param reqData 
     * @param progressCallback 
     * @param finshiCallback 
     */
    static downFile2Local(reqData: IFileRequestData, progressCallback?, finshiCallback?) {

        if (!jsb) return;

        //下载速度 未见完整性校验

        let fullPath = jsb.fileUtils.getWritablePath() + reqData.storageName + reqData.storageType;

        let downloader = new jsb.Downloader();
        downloader.setOnFileTaskSuccess(function () {

            if (finshiCallback) finshiCallback(null, fullPath);
        });
        downloader.setOnTaskError(function (task, errorcode, errorCodeInternal, errorStr) {

            if (++reqData.requestCount >= reqData.requestMax) {
                if (finshiCallback) {
                    finshiCallback(errorStr, null, reqData);
                }
            } else {
                Utility.downFile2Local(reqData, progressCallback, finshiCallback);
            }
            cc.log(" downFile2Local error ", reqData.requestCount);
        });

        let progress = 0;
        downloader.setOnTaskProgress(function (task, bytesReceived, totalBytesReceived, totalBytesExpected) {

            if (totalBytesExpected == -1) {
                progress += 0.01;
                if (progress > 0.99) {
                    progress = 0.99;
                }
            } else {
                progress = totalBytesReceived / totalBytesExpected;
            }
            if (progressCallback) progressCallback(progress);
        });

        downloader.createDownloadFileTask(reqData.url, fullPath);//创建下载任务
    }
    //字符串转byte[]
    static stringToBytes(str) {
        var ch, st, re = [];
        for (var i = 0; i < str.length; i++) {
            ch = str.charCodeAt(i);  // get char  
            st = [];                 // set up "stack"  

            do {
                st.push(ch & 0xFF);  // push byte to stack  
                ch = ch >> 8;          // shift value down by 1 byte  
            }

            while (ch);
            // add stack contents to result  
            // done because chars have "wrong" endianness  
            re = re.concat(st.reverse());
        }
        // return an array of bytes  
        return re;
    }

    static getCanvasFingerprint() {
        if (!cc.sys.isBrowser) {
            return ""
        }
        var canvas = document.createElement('canvas');
        var ctx = canvas.getContext('2d');
        // https://www.browserleaks.com/canvas#how-does-it-work
        var txt = 'http://valve.github.io';
        ctx.textBaseline = "top";
        ctx.font = "14px 'Arial'";
        ctx.textBaseline = "alphabetic";
        ctx.fillStyle = "#f60";
        ctx.fillRect(125, 1, 62, 20);
        ctx.fillStyle = "#069";
        ctx.fillText(txt, 2, 15);
        ctx.fillStyle = "rgba(102, 204, 0, 0.7)";
        ctx.fillText(txt, 4, 17);
        var b64 = canvas.toDataURL().replace("data:image/png;base64,", "");
        var bin = atob(b64);
        var crc = this.bin2hex(bin.slice(-18, -12));
        return crc;
    }
    static bin2hex(s) {
        var i, l, o = '',
            n;

        s += '';

        for (i = 0, l = s.length; i < l; i++) {
            n = s.charCodeAt(i)
                .toString(16);
            o += n.length < 2 ? '0' + n : n;
        }

        return o;
    }

    /**
    * 获取url参数
    * @param variable 
    */
    static getQueryVariable(variable) {
        var query = window.location.search.substring(1);
        var vars = query.split("&");
        for (var i = 0; i < vars.length; i++) {
            var pair = vars[i].split("=");
            if (pair[0] == variable) { return pair[1]; }
        }
        return (false);
    }
    static isSafari() {
        if (!navigator.userAgent.match('Safari')) {
            return false
        }
        //baidu
        var isBaidu = navigator.userAgent.match('baidu') != null;
        var isOpera = navigator.userAgent.match('Opera') != null;
        var isMaxthon = navigator.userAgent.match('Maxthon') != null;
        //QQ browser
        var isQQ = navigator.userAgent.match('MQQBrowser') != null;

        //Saferi Browser
        var isFirefox = navigator.userAgent.match('FxiOS') != null;
        var isFirefox2 = navigator.userAgent.match('Firefox') != null;
        // UC Browser
        var isUC = navigator.userAgent.indexOf("UCBrowser") != -1;

        // Chrome 1+
        var isChrome = navigator.userAgent.match('CriOS') != null;
        var isChrome2 = navigator.userAgent.match('Chrome') != null;
        //xiaomi
        var isXiaomi = navigator.userAgent.match('XiaoMi') != null;

        var isIos = navigator.userAgent.match('iPhone') != null || navigator.userAgent.match('iPad') != null

        var isLine = navigator.userAgent.match('Line') != null
        var isFacebook = navigator.userAgent.match('FB') != null
        //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~!!!!!!!!!!!!!!!!!

        //isSafari 变量在CocosCreator源码中用到不能随便删除！！！！！！！！！！

        //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~!!!!!!!!!!!!!!!!!
        // Safari 3.0+ "[object HTMLElementConstructor]"
        var isSafari = isIos && !isBaidu && !isFirefox && !isQQ && !isChrome && !isUC && !isXiaomi && !isChrome2 && !isLine && !isFacebook && !isFirefox2 && !isMaxthon && !isOpera;
        cc.log("navigator.userAgent:", isSafari, navigator.userAgent)
        return isSafari
    }
    static isIosChrome() {
        var isChrome = navigator.userAgent.match('CriOS') != null;
        var isIos = navigator.userAgent.match('iPhone') != null || navigator.userAgent.match('iPad') != null
        return isChrome && isIos
    }
    static openInLine() {
        var isLine = navigator.userAgent.match('Line') != null
        return isLine
    }
    static openInFacebook() {
        var isFacebook = navigator.userAgent.match('FB') != null
        return isFacebook
    }

    static isLandscape() {
        return (window.orientation == 90 || window.orientation == -90)
    }

    static getUrl(pathname = true) {

        let protocol = window.location.protocol;
        let host = window.location.host;

        if (pathname) {
            return protocol + "//" + host + window.location.pathname;

        } else {

            return protocol + "//" + host + "/";
        }
    }

    //上报转化事件
    static reportConversionEvent(action, actionData = 1) {
        if (cc.sys.isNative) {
            let value: AnalyticsParam = {
                value: actionData,
                "currency": "THB"
            }
            Utility.reportEvent(action, value)
        } 
    }

    static reportEvent(action, analyticsParam ?: AnalyticsParam) {
        if (CC_JSB) {
            AppController.instance.trackerEvent(action, analyticsParam)
        } else {
            //@ts-ignore
            if (!window.dataLayer) {
                return
            }
            //@ts-ignore
            let _gtag = gtag
            if (_gtag) {
                _gtag('event', action, analyticsParam);
            }
        }
    }


    //一小时上报一次
    static reportEffect(action, analyticsParam?) {
        let value: AnalyticsParam = {
            value: analyticsParam,
            "currency": "THB"
        }
        Utility.reportEvent(action, value)
    }


    //大于等于目标版本将返回true
    static version_judge(curVersion, targetVersion) {
        let curVersions = curVersion.split(".")
        let targetVersions = targetVersion.split(".")
        let fit = false
        if (curVersions.length == targetVersions.length) {
            for (let i = 0; i < curVersions.length; i++) {
                let c = this.parseInt(curVersions[i])
                let t = this.parseInt(targetVersions[i])
                if (i < curVersions.length - 1) {
                    if (c > t) {
                        fit = true
                        break
                    } else if (c < t) {
                        fit = false
                        break
                    }
                } else {
                    if (c >= t) {
                        fit = true
                    }
                }
            }
        }
        return fit
    }

    static isJSON(str) {
        if (typeof str == 'string') {
            try {
                var obj = JSON.parse(str);
                if (typeof obj == 'object' && obj) {
                    return true;
                } else {
                    return false;
                }

            } catch (e) {
                //console.log('error：'+str+'!!!'+e);
                return false;
            }
        }
        //console.log('It is not a string!')
        return false;
    }

    /** 
     * 对日期进行格式化， 
     * @param date 要格式化的日期 
     * @param format 进行格式化的模式字符串
     *     支持的模式字母有： 
     *     y:年, 
     *     M:年中的月份(1-12), 
     *     d:月份中的天(1-31), 
     *     h:小时(0-23), 
     *     m:分(0-59), 
     *     s:秒(0-59), 
     *     S:毫秒(0-999),
     *     q:季度(1-4)
     * @return String
     * @author yanis.wang@gmail.com
     */
    static dateFormat(dateOrFormat?, format?) {
        let date = dateOrFormat
        if (format === undefined) {
            format = date;
            date = new Date();
        }
        var map = {
            "M": date.getMonth() + 1, //月份 
            "d": date.getDate(), //日 
            "h": date.getHours(), //小时 
            "m": date.getMinutes(), //分 
            "s": date.getSeconds(), //秒 
            "q": Math.floor((date.getMonth() + 3) / 3), //季度 
            "S": date.getMilliseconds() //毫秒 
        };
        format = format.replace(/([yMdhmsqS])+/g, function (all, t) {
            var v = map[t];
            if (v !== undefined) {
                if (all.length > 1) {
                    v = '0' + v;
                    v = v.substr(v.length - 2);
                }
                return v;
            }
            else if (t === 'y') {
                return (date.getFullYear() + '').substr(4 - all.length);
            }
            return all;
        });
        return format;
    }

    static urlParse(url){        
        if(!url) return null
        let data = null
        try {
            if (URLJS == null) {
                URLJS = require('../lib/url.min.js')
            }
            data = URLJS(url)
            if(data.query != ''){                
                data.queryMap = this.getAllUrlParams(data.query)
            }
        } catch (error) {
            cc.warn(error)            
        }
        
        return data
    }

    static getAllUrlParams(url) {
        if(!url){
            return null
        }
        let map = {}
        let list = url.split('&')
        for (let index = 0; index < list.length; index++) {
            let array = list[index].split('=')
            let val
            let isNumberReg = new RegExp('^[-+]?(([0-9]+)([.]([0-9]+))?|([.]([0-9]+))?)$', 'g')
            if(isNumberReg.test(array[1])){
                val = Number(array[1])
            }else if(array[1] == 'true'){
                val = true
            }else if(array[1] == 'false'){
                val = false
            }else{
                val = array[1]
            }
            map[array[0]] = val
        }
        return map
    }
}